"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Odnoklassniki = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Odnoklassniki = function Odnoklassniki(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.829 8.666a1.127 1.127 0 011.41 1.76c-.053.041-1.047.828-2.707 1.166l2.505 2.483a1.127 1.127 0 01-1.593 1.595l-2.432-2.368-2.21 2.353a1.124 1.124 0 01-1.594.03 1.127 1.127 0 01-.029-1.595l2.379-2.485c-1.707-.33-2.743-1.137-2.796-1.18a1.127 1.127 0 011.41-1.759c.01.008 1.094.822 2.84.823 1.745 0 2.806-.815 2.816-.823zM8.067 0a4.146 4.146 0 110 8.292 4.146 4.146 0 010-8.292zm0 2.432a1.714 1.714 0 100 3.428 1.714 1.714 0 000-3.428z",
    fill: "currentColor"
  }));
};

exports.Odnoklassniki = Odnoklassniki;
var _default = Odnoklassniki;
exports.default = _default;